import { Checkbox, FormControlLabel, Text } from "designSystem/index";
import RTLWrapper from "designSystem/components/rtl/RTLWrapper";
import React, { useState } from "react";
import CssColumnGrid from "../../CssColumnGrid";

export default () => {
	const [checked, setChecked] = useState(false);

	function onChange(event: object, value: boolean): void {
		setChecked(value);
	};

	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="Labeled Checkbox" />
			<Text semiBold text="Disabled Labeled Checkbox" />
			<RTLWrapper inline>
				<Checkbox
					checked={checked}
					labelProps={{
						label: "End Label",
					}}
					onChange={onChange}
				/>
			</RTLWrapper>
			<RTLWrapper inline>
				<Checkbox
					checked={checked}
					disabled
					labelProps={{
						label: "End Label",
					}}
					onChange={onChange}
				/>
			</RTLWrapper>
		</CssColumnGrid>
	);
};
